import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9062 14C15.4688 16.5 12.8438 18 10 18ZM7.46875 7.46875C7.15625 7.78125 7.15625 8.25 7.46875 8.53125L8.9375 10L7.46875 11.4688C7.15625 11.7812 7.15625 12.25 7.46875 12.5312C7.75 12.8437 8.21875 12.8437 8.5 12.5312L9.96875 11.0625L11.4375 12.5312C11.75 12.8437 12.2188 12.8437 12.5 12.5312C12.8125 12.25 12.8125 11.7812 12.5 11.4687L11.0313 10L12.5 8.53125C12.8125 8.25 12.8125 7.78125 12.5 7.46875C12.2188 7.1875 11.75 7.1875 11.4375 7.46875L9.96875 8.9375L8.5 7.46875C8.21875 7.1875 7.75 7.1875 7.46875 7.46875Z"
	})
});
const ForwardRef = forwardRef(SvgErrorFilled);
export default ForwardRef;
